<template>
  <div class="mt-2">
    <v-card>
      <v-toolbar
        dense
        color="white"
        class="elevation-0"
      >
        <v-toolbar-title>
          <v-icon>mdi-calendar-check</v-icon>
          משימות
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          @click="createTask"
          text
          color="primary"
        >
          <v-icon class="me-2">mdi-plus</v-icon>
          הוספת משימה
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <v-progress-linear
          indeterminate
          height="2"
          v-if="fetching"
        ></v-progress-linear>
        <template v-else-if="tasks.length">
          <v-data-table
            :headers="headers"
            :items="tasks"
            hide-default-footer
            disable-sort
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <v-btn
                    fab x-small dark class="elevation-0"
                    :to="`/tasks/${item._id}`"
                    :color="taskTypeById(item.type).color"
                  >
                    <v-icon>
                      {{ taskTypeById(item.type).icon }}
                    </v-icon>
                  </v-btn>
                </td>
                <td>
                  <router-link :to="`/tasks/${item._id}`">{{ taskTypeById(item.type).title }}</router-link>
                </td>
                <td>{{ heDate(item.dueDate) }}</td>
                <td>{{ item.completedBy ? userById(item.completedBy) ? userById(item.completedBy).name : 'לא ידוע' : 'לא בוצעה'  }}</td>
              </tr>
            </template>
          </v-data-table>
        </template>
        <v-alert
          :value="true"
          color="white"
          class="ma-0 grey--text"
          v-else
        >
          אין משימות
        </v-alert>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { format, isAfter } from "date-fns";
import generateId from "@/idGenerator";
import mixins from "@/mixins/mixins";

export default {
  data() {
    return {
      fetching: false,
      filters: [],
      headers: [
        { text: "סוג", align: "right", value: "type" },
        { text: "שם", align: "right", value: "type" },
        { text: "תאריך לביצוע", align: "right", value: "date" },
        { text: "בוצעה ע״י", align: "right", value: "completedBy" }
      ],
      options: {
        sortDesc: [true],
        sortBy: ["created"]
      }
    };
  },
  methods: {
    format,
    fetch() {
      this.fetching = true;
      let query = {
        order: this.order
      };
      this.$store
        .dispatch("API_GET", {
          url: "/tasks",
          entityType: "tasks",
          schema: "taskListSchema",
          params: { q: JSON.stringify(query) }
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    taskTypeById(id) {
      return this.$store.state.entities.taskTypes[id];
    },
    userById(id) {
      return this.$store.state.entities.users[id];
    },
    createTask() {
      let newEntity = {
        _id: generateId(),
        order: this.order
      };
      let resource = this.$store.state.resources.task;
      this.editEntity(newEntity, resource, true);
    },
  },
  computed: {
    tasks() {
      return Object.values(this.$store.state.entities.tasks)
        .filter(item => {
          return item.order === this.order;
        })
        .sort((a, b) => {
          return isAfter(a.created, b.created) ? -1 : 1;
        });
    },
    resource() {
      return this.$store.state.resources["task"];
    }
  },
  props: ["order"],
  watch: {},
  mounted() {
    this.fetch();
  },
  components: {},
  mixins: [mixins]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>